/* UI-DESIGN: Host controls restyled into the Whodunit dark card language.
   NOTE: this page is still a local-state demo — none of these controls call
   the backend yet (same as before the redesign). Navigation moved from
   window.location.href to the router so the SPA doesn't full-reload. */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
/* UI-DESIGN: CaseMark wraps the puzzle set's mark (Lotus today, swappable per theme) */
import LightboxSurface from "../../components/lightbox/LightboxSurface";
import GlassPanel from "../../components/lightbox/GlassPanel";
import styles from "./Host.module.scss";

type GameState = "Inviting" | "Pre-game" | "In-Progress" | "Post-game";
type Mystery = "The White Lotus Murder" | "The Casino Heist" | "The Resort Conspiracy";

const Host = () => {
  const [gameState, setGameState] = useState<GameState>("Inviting");
  const [currentRound, setCurrentRound] = useState<number>(1);
  const [selectedMystery, setSelectedMystery] = useState<Mystery>("The White Lotus Murder");
  const navigate = useNavigate();

  return (
    <LightboxSurface mode="static" onUnavailable={() => {}}>
    <div className={styles.page}>
      <h1 className={clsx(styles.title, "ui-reveal", "ui-reveal-1")}>Host controls</h1>
      <p className={clsx(styles.subtitle, "ui-reveal", "ui-reveal-1")}>
        Preview the mystery and round controls
      </p>


      <GlassPanel className={styles.card}>
        <div className={styles.field}>
          <label className={styles.fieldLabel} htmlFor="host-game-state">
            Game State
          </label>
          <select
            id="host-game-state"
            className={styles.select}
            value={gameState}
            onChange={(e) => setGameState(e.target.value as GameState)}
          >
            <option value="Inviting">Inviting</option>
            <option value="Pre-game">Pre-game</option>
            <option value="In-Progress">In-Progress</option>
            <option value="Post-game">Post-game</option>
          </select>
        </div>

        {gameState === "In-Progress" && (
          <div className={styles.field}>
            <label className={styles.fieldLabel} htmlFor="host-current-round">
              Current Round
            </label>
            <select
              id="host-current-round"
              className={styles.select}
              value={currentRound}
              onChange={(e) => setCurrentRound(Number(e.target.value))}
            >
              {[1, 2, 3, 4, 5].map((round) => (
                <option key={round} value={round}>Round {round}</option>
              ))}
            </select>
          </div>
        )}

        <div className={styles.field}>
          <label className={styles.fieldLabel} htmlFor="host-mystery">
            Select Mystery
          </label>
          <select
            id="host-mystery"
            className={styles.select}
            value={selectedMystery}
            onChange={(e) => setSelectedMystery(e.target.value as Mystery)}
          >
            <option value="The White Lotus Murder">The White Lotus Murder</option>
            <option value="The Casino Heist">The Casino Heist</option>
            <option value="The Resort Conspiracy">The Resort Conspiracy</option>
          </select>
        </div>

        <div className={styles.buttons}>
          <button
            type="button"
            className={styles.secondaryButton}
            onClick={() => navigate("/lobby")}
          >
            Back to Lobby
          </button>
          <button type="button" className={styles.primaryButton}>
            Save Changes
          </button>
        </div>
      </GlassPanel>
    </div>
    </LightboxSurface>
  );
};

export default Host;
